import styled from 'styled-components';

export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 30px;
`;

export const ModalDescription = styled.p`
  font-size: 18px;
  font-weight: 400;
  color: #212529;

  &:not(:first-of-type) {
    padding-top: 30px;
  }

  .tooltip-container {
    margin-left: 8px;
  }
`;
